import { useEffect, useState } from 'react'
import IconButton from '@mui/material/IconButton'
import { OpenInNewRounded } from '@mui/icons-material'
import { FormControl, MenuItem, Select, SelectChangeEvent, Stack, Dialog, Box, Typography } from '@mui/material'
import { ReadTaskSummaryData } from '@common/config/api/client'
import FormRendererDialog from '@features/subject/components/FormRendererDialog'

interface TimepointOption {
  value: string
  label: string
}

interface TimepointEformModalProps {
  timepoints: ReadTaskSummaryData['timepoints']
  index: number
}

export default function TimepointEformModal({ timepoints, index }: TimepointEformModalProps) {
  const [open, setOpen] = useState(false)
  const [selectedTimepointIndex, setSelectedTimepointIndex] = useState(index)
  const [showSelector, setShowSelector] = useState(false)

  useEffect(() => {
    if (open) {
      setSelectedTimepointIndex(index)
    }
  }, [open, index])

  const options: TimepointOption[] = timepoints
    .map((timepoint, i) =>
      timepoint.timepoint_eform_submission ? { value: i.toString(), label: timepoint.timepoint_name } : null,
    )
    .filter((option): option is TimepointOption => option !== null)

  const handleChange = (event: SelectChangeEvent<string>) => {
    setSelectedTimepointIndex(Number(event.target.value))
  }

  const handleClose = () => {
    setOpen(false)
    setShowSelector(false)
  }

  const selectedTimepoint = timepoints[selectedTimepointIndex]

  return (
    <>
      <IconButton onClick={() => setOpen(true)} aria-label="Open Timepoint eForm">
        <OpenInNewRounded />
      </IconButton>

      {showSelector && (
        <Dialog open={showSelector} onClose={() => setShowSelector(false)}>
          <Box sx={{ p: 3, width: '300px' }}>
            <Typography variant="h6" mb={2}>
              Select Timepoint
            </Typography>
            <FormControl fullWidth>
              <Select
                value={selectedTimepointIndex.toString()}
                onChange={handleChange}
                displayEmpty
                inputProps={{ 'aria-label': 'Select Timepoint' }}
              >
                {options.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Stack direction="row" justifyContent="flex-end" mt={2}>
              <IconButton onClick={() => setShowSelector(false)}>
                <OpenInNewRounded />
              </IconButton>
            </Stack>
          </Box>
        </Dialog>
      )}

      {open && (
        <FormRendererDialog
          header={`Timepoint eForm: ${selectedTimepoint.timepoint_name}`}
          onClose={handleClose}
          fields={JSON.stringify(selectedTimepoint.timepoint_eform_definition || [])}
          values={JSON.stringify(selectedTimepoint.timepoint_eform_submission)}
          onSubmit={() => {}}
          readOnly={true}
        />
      )}
    </>
  )
}
